module.exports = __webpack_public_path__ + "img/HealthInformation.b44e418b.svg";